import { errorAPIGateway } from '@/vos/errors/apiGateway.vo';
import { errorFirebase } from '@/vos/errors/firebase.vo';
import { errorDefault } from '@/vos/errors/default';
import { kyHttpError } from '@/vos/errors/kyHttpError';
import { axiosHttpError } from '@/vos/errors/axiosHttpError';

export interface ErrorParser {
  parse(error: unknown): Promise<string | null>;
}

export function errorParserFactory(error: unknown): ErrorParser {
  if (errorAPIGateway.isErrorAPIGateway(error)) return errorAPIGateway;

  if (errorFirebase.isErrorFirebase(error)) return errorFirebase;

  if (kyHttpError.isKyHttpError(error)) return kyHttpError;

  if (axiosHttpError.isAxiosHttpError(error)) return axiosHttpError;

  return errorDefault;
}
